import {
  AfterViewInit,
  Component,
  ElementRef,
  HostListener,
  OnChanges,
  OnInit,
  SimpleChanges,
  ViewChild
} from '@angular/core';
import {ActivatedRoute, NavigationEnd, Router} from '@angular/router';

import { AuthenticationService} from '@app/core/authentication/authentication.service';
import {Credentials, CredentialsService} from '@app/core/authentication/credentials.service';
import { I18nService } from '@app/core/i18n.service';
import {BackendService} from "@app/core/backendService/backend.service";
import {HeaderService} from "@app/shell/header/header.service";
import {filter, map} from "rxjs/operators";
import {includes} from 'lodash-es'
import {Observable} from "rxjs";
import {FlashMessageService} from "@shared/partials/flash-message/flash-message.service";
import {FlashMessage} from "@shared/partials/flash-message/flash-message.models";

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit, OnChanges, AfterViewInit{

  public menuHidden:boolean
  public noSpacer:boolean
  public isTransparent:boolean
  public forceOpaque:boolean
  public isScroll:boolean
  public configuration: any

  public role: string
  public first_name: string
  public username: string
  public participant_id: number

  @ViewChild('mainNavHeader' , {static: false}) navHtmlElement: ElementRef
  @ViewChild('navbarToggler', { static: false }) navbarToggler: ElementRef;

  @HostListener('window:scroll', ['$event.target'])
  onWindowScroll() {
    let top = window.scrollY
    this.isScroll = top > 10
  }

  constructor(
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private authenticationService: AuthenticationService,
    private credentialsService: CredentialsService,
    private i18nService: I18nService,
    private backendService: BackendService,
    private headerService: HeaderService,
    private flashMessageService: FlashMessageService,
  ) {
    this.menuHidden = false;
    this.noSpacer = false;
    this.isTransparent = false;
    this.forceOpaque = false;
    this.isScroll = false;
    this.configuration = {}

    this.role = undefined
    this.first_name = undefined
    this.username = undefined
    this.participant_id = undefined

    this.router.events.pipe(
      filter( event => event instanceof NavigationEnd )
    )
      .subscribe( (e: NavigationEnd) => {
        if(e.urlAfterRedirects.search(/^\/home/i) !== -1){
          this.noSpacer = true;
          this.isTransparent = true;
        }
        else{
          this.noSpacer = false;
          this.isTransparent = false;
        }
      });

    this.backendService.config$.subscribe((configuration:any)=>{
      this.configuration = configuration
    })

    this.credentialsService.change$.subscribe((credentials:Credentials)=>{
      this.role = credentials && credentials.role
      this.first_name = credentials && credentials.first_name
      this.username = credentials && credentials.username
      this.participant_id = credentials && credentials.participant_id
    })
  }

  ngOnInit() {
    this.flashMessageService.showMessage$.subscribe((message:FlashMessage|null)=>{
      this.forceOpaque= !!message
    })
  }

  toggleMenu() {
    this.menuHidden = !this.menuHidden;
  }

  setLanguage(language: string) {
    this.i18nService.language = language;
  }

  logout() {
    this.authenticationService.logout()
      .subscribe(() => {
        this.router.navigate([''], { replaceUrl: true })
      });
  }

  isUserAuthenticated(){
    return this.credentialsService.isAuthenticated()
  }

  get currentLanguage(): string {
    return this.i18nService.language;
  }

  get languages(): string[] {
    return this.i18nService.supportedLanguages;
  }

  isDummyEmail(email:string=''){ return this.backendService.isDummyEmail(email) }

  emitHeightChange(){
    if(this.navHtmlElement && this.navHtmlElement.nativeElement){
      this.headerService.heightChange$.next(this.navHtmlElement.nativeElement.offsetHeight)
    }
  }

  ngAfterViewInit(): void {
    this.emitHeightChange()
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.emitHeightChange()
  }

  public toggleNavbar(){
    this.navbarToggler.nativeElement.click()
  }

}
